import React from "react";
import {
  Box,
  Button,
  Chip,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function LandingStudioQuestionDock({
  question,
  progress,
  onResolve,
  onSelectStep,
}) {
  return (
    <Box
      component="aside"
      sx={{
        position: "fixed",
        inset: "auto 0 0 0",
        zIndex: 1050,
        bgcolor: "rgba(255,255,255,.97)",
        borderTop: "1px solid rgba(25,36,47,.10)",
        backdropFilter: "blur(18px)",
        boxShadow: "0 -14px 40px rgba(25,36,47,.08)",
      }}
    >
      <LinearProgress
        variant="determinate"
        value={progress?.percentage || 0}
        sx={{
          height: 4,
          bgcolor: "rgba(25,36,47,.06)",
          "& .MuiLinearProgress-bar": {
            bgcolor: progress?.complete ? "#16834b" : BRAND.orange,
          },
        }}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ md: "center" }}
        justifyContent="space-between"
        spacing={1.2}
        sx={{ px: { xs: 1.4, sm: 2.2 }, pt: 1.25, pb: 0.85 }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Stack direction="row" spacing={0.8} alignItems="center">
            {question?.complete ? (
              <CheckCircleRoundedIcon sx={{ color: "#16834b", fontSize: 20 }} />
            ) : (
              <Chip
                size="small"
                label={question?.stepLabel || "Siguiente paso"}
                sx={{ height: 22, fontWeight: 900, color: BRAND.orange, bgcolor: "rgba(243,90,58,.09)" }}
              />
            )}
            <Typography variant="caption" sx={{ color: "rgba(25,36,47,.52)", fontWeight: 800 }}>
              {progress?.percentage || 0}% completo
            </Typography>
          </Stack>
          <Typography
            sx={{
              mt: 0.35,
              fontSize: { xs: 16, sm: 18 },
              fontWeight: 950,
              color: BRAND.dark,
              lineHeight: 1.15,
            }}
          >
            {question?.question}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mt: 0.2,
              color: "rgba(25,36,47,.58)",
              display: { xs: "none", sm: "block" },
            }}
          >
            {question?.hint}
          </Typography>
        </Box>

        <Button
          variant="contained"
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={onResolve}
          sx={{
            flex: "0 0 auto",
            borderRadius: 999,
            px: 2.2,
            minHeight: 42,
            textTransform: "none",
            fontWeight: 950,
            bgcolor: question?.complete ? "#16834b" : BRAND.orange,
            boxShadow: "none",
            "&:hover": {
              bgcolor: question?.complete ? "#106d3d" : "#dc482c",
              boxShadow: "none",
            },
          }}
        >
          {question?.complete ? "Revisar publicación" : "Completar ahora"}
        </Button>
      </Stack>

      <Stack
        direction="row"
        spacing={0.7}
        sx={{
          px: { xs: 1.4, sm: 2.2 },
          pb: 1.15,
          overflowX: "auto",
          scrollbarWidth: "thin",
        }}
      >
        {(progress?.steps || []).map((step) => (
          <Button
            key={step.id}
            size="small"
            onClick={() => onSelectStep(step)}
            sx={{
              flex: "0 0 auto",
              minWidth: 0,
              px: 1.15,
              py: 0.35,
              borderRadius: 999,
              textTransform: "none",
              fontSize: 12,
              fontWeight: 850,
              color: step.done ? "#16834b" : "rgba(25,36,47,.66)",
              bgcolor: step.done ? "rgba(22,131,75,.08)" : "rgba(25,36,47,.045)",
            }}
          >
            {step.done ? "✓ " : ""}{step.shortLabel || step.label}
          </Button>
        ))}
      </Stack>
    </Box>
  );
}
